/** Prefer string fields; if API nests file metadata under `video`, read .url/.path/.file */
export function extractVideoLocationString(record) {
  if (!record || typeof record !== "object") return "";
  const tryScalar = (x) =>
    typeof x === "string" && x.trim() && x.trim() !== "[object Object]"
      ? x.trim()
      : "";

  const keysFlat = [
    "video_url",
    "videoUrl",
    "video_path",
    "videoPath",
    "media_url",
    "mediaUrl",
  ];
  for (const k of keysFlat) {
    const hit = tryScalar(record[k]);
    if (hit) return hit;
  }

  const videoField = record.video;
  if (videoField != null && typeof videoField === "object") {
    const sub =
      tryScalar(videoField.url) ||
      tryScalar(videoField.path) ||
      tryScalar(videoField.file) ||
      tryScalar(videoField.link) ||
      tryScalar(videoField.src);
    if (sub) return sub;
  }
  const asStringFallback = tryScalar(videoField);

  const generic =
    tryScalar(record.url) ||
    tryScalar(record.link) ||
    tryScalar(record.file) ||
    asStringFallback;
  return generic;
}

/** Map API document to consistent UI shape */
export function mapVideoFromApi(v) {
  if (!v || typeof v !== "object") return null;
  const productIdRaw = v.product_id ?? v.productId ?? v.product?._id ?? "";
  const productName = String(
    v.product_name ??
      v.product?.name ??
      v.product_data?.name ??
      v.product_info?.product_name ??
      v.product_detail?.name ??
      ""
  ).trim();
  return {
    _id: v._id,
    videoUrl: extractVideoLocationString(v),
    productId:
      productIdRaw != null && productIdRaw !== ""
        ? String(productIdRaw)
        : "",
    productName,
  };
}

export function normalizeVideoList(data) {
  if (Array.isArray(data)) return data.map(mapVideoFromApi).filter(Boolean);
  if (Array.isArray(data?.videos))
    return data.videos.map(mapVideoFromApi).filter(Boolean);
  if (Array.isArray(data?.list))
    return data.list.map(mapVideoFromApi).filter(Boolean);
  return [];
}
